export const CREATE_DIAGNOSIS = {
    REQUEST:"CREATE_DIAGNOSIS_REQUEST",
    SUCCESS:"CREATE_DIAGNOSIS_SUCCESS",
    FAIL:"CREATE_DIAGNOSIS_FAIL",
}


export const GET_DIAGNOSIS = {
    REQUEST:"GET_DIAGNOSIS_REQUEST",
    SUCCESS:"GET_DIAGNOSIS_SUCCESS",
    FAIL:"GET_DIAGNOSIS_FAIL",
}

export const DELETE_DIAGNOSIS = {
    REQUEST:"DELETE_DIAGNOSIS_REQUEST",
    SUCCESS:"DELETE_DIAGNOSIS_SUCCESS",
    FAIL:"DELETE_DIAGNOSIS_FAIL",
}